import React from 'react'
import PropTypes from 'prop-types'

import { Input, Select, Button, IconButton } from '@st-operations/uikit/src/v2/index.js'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'

import './styles.scss'

const body = document.querySelector('body')

const CreateEventFeedModal = ({
  daasClients,
  handleCreateFeed,
  modalOpen,
  newFeedValues,
  setNewFeedValues,
  toggleModal,
}) => {
  return (
    <Dialog open={modalOpen} close={toggleModal} className="create-event-feed-modal__modal">
      <div className="create-event-feed-modal__modal-close">
        <IconButton
          onClick={toggleModal}
          aria-label="Close modal"
          className={''}
          iconProps={{
            icon: 'delete',
            type: 'fill',
            width: 16,
            height: 16,
            color: '#000',
          }}
        />
      </div>
      <Input
        label="Feed Name"
        name="Feed Name"
        onChange={(value) => setNewFeedValues((values) => ({ ...values, name: value }))}
        value={newFeedValues.name}
      />
      <Select
        isSearchable={true}
        label="Client"
        name="Client"
        onChange={(_, _2, value) => setNewFeedValues((values) => ({ ...values, client: value }))}
        options={daasClients}
        useReactSelect={true}
        value={newFeedValues.client}
        menuPosition="fixed"
        menuPortalTarget={body}
        styles={{ menuPortal: (provided) => ({ ...provided, zIndex: 9999, maxHeight: 200 }) }}
      />
      <Input
        disabled
        label="Date Created"
        name="Date Created"
        readOnly
        value={new Date().toISOString().split('T')[0]}
      />
      <Button
        onClick={handleCreateFeed}
        className="create-event-feed-modal__modal-confirm"
        disabled={newFeedValues.name && newFeedValues.client.name ? false : true}
      >
        Create Feed
      </Button>
    </Dialog>
  )
}

CreateEventFeedModal.propTypes = {
  daasClients: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
  handleCreateFeed: PropTypes.func,
  modalOpen: PropTypes.bool,
  newFeedValues: PropTypes.shape({
    name: PropTypes.string,
    client: PropTypes.shape(),
  }),
  setNewFeedValues: PropTypes.func,
  toggleModal: PropTypes.func,
}

CreateEventFeedModal.defaultProps = {
  daasClients: [],
  handleCreateFeed: () => {},
  modalOpen: false,
  newFeedValues: {},
  setNewFeedValues: () => {},
  toggleModal: () => {},
}

export default CreateEventFeedModal
